/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * New component modal state
 *
 * @type {Object}
 */
const state = {
    value: {
        headers: [],
        title: '',
        stylings: [],
        rows: []
    },
    loading: false,
    error: false
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/dom/new-table/state.js